module.exports = {
    hole: function(maxLeadDia, holeOverLead) {
        return maxLeadDia + holeOverLead;
    },

    pad: function(holeDia, annularRingWidth, fabAllowance, padToHoleRatio) {
        return Math.max(holeDia + 2 * annularRingWidth + fabAllowance, padToHoleRatio * holeDia);
    }
};